'use client';

import { useEffect, useRef } from 'react';

export default function ProjectToolEmbed() {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const handleMessage = (e: MessageEvent) => {
      if (e.data.type === 'url-checker-resize' && iframeRef.current) {
        iframeRef.current.style.height = e.data.height + 'px';
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <div className="my-10 -mx-[70px] md:-mx-[74px] lg:-mx-[82px]">
      <div className="w-full rounded-2xl overflow-hidden bg-secondary/30 backdrop-blur-sm border border-accent/20 shadow-cosmic">
        <iframe
          ref={iframeRef}
          id="checker-iframe"
          src="https://ai-website-checker.netlify.app/?embed=1"
          title="AI Website Checker"
          loading="lazy"
          className="w-full border-none bg-transparent"
          style={{ minHeight: '600px', maxWidth: '100%' }}
          allowTransparency
        />
      </div>
    </div>
  );
}